import React from 'react';
import Reflux from 'reflux';
import SpinnerStore from 'flux/stores/SpinnerStore';
import Spinner from 'shared/components/misc/simpleSpinner';
import classNames from 'classnames';

/**
 * Spinner Container
 *
 */
export default React.createClass({
  mixins: [Reflux.connect(SpinnerStore, 'spinnerVisibility')],

  propTypes: {
    name: React.PropTypes.string,
    display: React.PropTypes.bool, //Overwrites store visibility state
  },

  displayName: 'SpinnerContainer',

  getDefaultProps() {
    return {
      fade: true,
      display: true,
      relative: false,
    };
  },

  render() {
    return this.isVisible() ? (
      <Spinner relative={this.props.relative} />
    ) : (
      <div className={classNames({ 'fade-in': this.props.fade })}>
        {this.props.children}
      </div>
    );
  },

  isVisible() {
    const { name, display } = this.props;

    //If display is false spinner should not be visible
    if (!display) return false;

    return this.state.spinnerVisibility.get(name) ? true : false;
  },
});
